import { DefaultFilters } from '@backstage/plugin-catalog-react';
import {
  EntityUserCountryPicker,
  EntityUserDepartmentPicker,
  EntityUserOfficePicker,
  EntityUserRolePicker,
} from './filters/UserAnnotationPickers';

/**
 * Catalog filter rail — stock DefaultFilters plus PAT-422's user-identity
 * annotation facets (Role / Department / Office / Country). The annotation
 * pickers self-hide when no entities in the loaded scope carry the value,
 * so they only appear on /catalog?kind=user (where users have the
 * annotations) and stay out of the way for other entity kinds.
 */
export const CustomCatalogFilters = () => (
  <>
    <DefaultFilters />
    <EntityUserRolePicker />
    <EntityUserDepartmentPicker />
    <EntityUserOfficePicker />
    <EntityUserCountryPicker />
  </>
);
